import { store as commonStore } from '@febos-io/common';
import { store as healthCommonStore } from '@febos-io/health-common';
import { store as authStore } from '@febos-io/auth';

export default {
  common: commonStore.initialState,
  healthCommon: healthCommonStore.initialState,
  auth: authStore.initialState
};
